import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Spin, Form, Divider, Col } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { chargeApi, chargeLabel, chargeStatic } from "./charge.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const DetailCharge = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [chargeDetail, setChargeDetail] = useState({});
  const [inputField, setInputField] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${chargeApi.Charges}/${state.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setChargeDetail(objDetail);
        setIsLoading(false);

        setInputField([
          {
            name: chargeLabel.chargeId,
            value: objDetail.id,
          },
          {
            name: chargeLabel.chargeName,
            value: objDetail.name,
          },
          {
            name: chargeLabel.amount,
            value: objDetail.amount,
          },
          {
            name: chargeLabel.currency,
            value: objDetail.currency.displayLabel,
          },
          {
            name: chargeLabel.chargeAppliesTo,
            value: objDetail.chargeAppliesTo.value,
          },
          {
            name: chargeLabel.isPenalty,
            value: objDetail.penalty,
          },
          {
            name: chargeLabel.chargeCalculationType,
            value: objDetail.chargeCalculationType.value,
          },
          {
            name: chargeLabel.chargePaymentMode,
            value: objDetail.chargePaymentMode.value,
          },
          {
            name: chargeLabel.chargeTimeType,
            value: objDetail.chargeTimeType.value,
          },
          {
            name: chargeLabel.freeWithdrawal,
            value: objDetail.freeWithdrawal,
          },
          {
            name: chargeLabel.isPaymentType,
            value: objDetail.isPaymentType,
          },
          {
            name: chargeLabel.restartFrequency,
            value: objDetail.restartFrequency,
          },
        ]);
        // ENABLE DELETE BUTTON
        if (!state.variant) {
          {
            BOM.HasPermission("DELETE_CHARGE") &&
              dispatch({
                type: cnt.RIGHT_DELETE_BTN,
              });
          }
        }

        setIsLoading(false);
      }
    });
  };

  const handleOnDelete = () => {
    let action = "Delete  ";
    let label = chargeDetail.name;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        const url = `${chargeApi.Charges}/${chargeDetail.id}`;

        const body = {
          method: "DELETE",
          session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, chargeLabel.deleteChargeMsg);
              navigate("/prd1000");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/prd1000");
              setIsLoading(false);
            },
          }
        );
      },
      function () {
        // No button
      }
    );
  };
  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={chargeLabel.chargeDetail}
        pageItems={
          state.variant
            ? chargeStatic.viewChargeBreadCrumbItems
            : chargeStatic.detailChargeItems
        }
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {chargeLabel.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              {inputField.map((item, index) => (
                <Col span={8} style={{ padding: "0px 8px" }} key={index}>
                  <Form.Item label={<Text strong>{item.name}</Text>}>
                    <Input
                      disabled
                      value={item.value}
                      className="of-bold-disable-input"
                    />
                  </Form.Item>
                </Col>
              ))}
            </Row>
          </Form>
        </Card>

        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailCharge);
